import * as dat from 'lil-gui'

export default class Debug
{
    constructor()
    {
        this.ui = new dat.GUI({ closeFolders: true })
    }
}